export const handleMoozikServiceError = (data) => {
  if (data?.code === "ECONNABORTED") {
    return {
      code: 600,
      response: data,
      texte: "Erreur de connexion",
      description: "La requete a été interrompue, veuillez réessayer",
    };
  }

  if (data.statuscode) {
    let errorCode = +data.statuscode;
    switch (errorCode) {
      case 200:
        return {
          code: 200,
          response: data,
          texte: "Ok",
          description: "La requete a été traitée avec succès",
        };
      case 401:
        return {
          code: 401,
          response: data,
          texte: "Non autorisé",
          description: "Le “token” fourni est non valide",
        };
      case 405:
        return {
          code: 405,
          response: data,
          texte: "Méthode non autorisée",
          description: "La méthode utilisée n'est pas autorisée",
        };
      case 400:
        return {
          code: 400,
          response: data,
          texte: "Paramètre manquant",
          description:
            "Un ou plusieurs paramètres requis sont manquants, ou au format incorrect",
        };
      case 500:
        return {
          code: 500,
          response: data,
          texte: "Erreur du serveur",
          description: "Une erreur interne du serveur s'est produite",
        };
      default:
        return {
          code: errorCode.statuscode,
          response: data,
          texte: "Erreur inconnue",
          description: "Erreur inconnue",
        };
    }
  } else {
    return {
      code: -1,
      response: data,
      texte: "Erreur inconnue",
      description: "Erreur inconnue",
    };
  }
};
